<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.03027 2.23389C10.2563 2.23389 12.2127 3.38289 13.333 5.11768V3.1665C13.3332 2.87224 13.572 2.63355 13.8662 2.6333C14.1607 2.6333 14.4002 2.87209 14.4004 3.1665V6.50049C14.4002 6.79488 14.1606 7.03369 13.8662 7.03369H10.5332C10.2388 7.03362 10.0002 6.79483 10 6.50049C10 6.20598 10.2387 5.96736 10.5332 5.96729H12.5986C11.7038 4.37683 9.99456 3.30029 8.03027 3.30029C5.13796 3.30049 2.79883 5.63154 2.79883 8.50049C2.79906 11.3692 5.1381 13.6995 8.03027 13.6997C10.6549 13.6997 12.8258 11.7799 13.2041 9.28076C13.2482 8.98954 13.5203 8.78849 13.8115 8.83252C14.1028 8.87658 14.3028 9.1487 14.2588 9.43994C13.8022 12.4574 11.186 14.7671 8.03027 14.7671C4.55463 14.7669 1.73167 11.9639 1.73145 8.50049C1.73145 5.03681 4.55449 2.23408 8.03027 2.23389Z"
      fill="#33363D"
    />
  </svg>
</template>
